export default "public/abb-logo_red.svg";